var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("span", [_vm._v("URL")]),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  placeholder: "https://www.youtube.com",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.listItem.data.url,
                  "error-messages": _vm.errorMessages.url,
                },
                on: { input: _vm.parseURL },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "", align: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "v-row",
                { attrs: { "no-gutters": "", align: "center" } },
                [
                  _c("MediaFilePicker", {
                    attrs: {
                      label: "Постер",
                      multiple: false,
                      "file-type": _vm.$options.mediaTypesByKeys.IMAGE,
                      value: _vm.listItem.data.poster,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.addImageHandler($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "span",
            [_vm._v("Заголовок ("), _c("TranslationIcon"), _vm._v(")")],
            1
          ),
          _c("QuillEditorVue", {
            attrs: {
              cols: 12,
              title: "Заголовок",
              content: _vm.listItem.data.caption,
              disabled: _vm.isLoading,
              loading: _vm.isLoading,
              "light-mode": "",
            },
            on: {
              input: function ($event) {
                return _vm.mixChangeListItemHandler($event, "caption")
              },
              onChangeContent: function ($event) {
                return _vm.mixChangeListItemHandler(
                  $event,
                  "descriptionForMobile"
                )
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }